const STORAGE_KEY = 'notificationBannerDismissed';

const banner = document.querySelector('.notification-banner');

if (banner) {
    const bannerId = banner.dataset.bannerId;
    const dismissable = banner.dataset.dismissable === '1';
    const dismissed = dismissable ? localStorage.getItem(STORAGE_KEY) : null;

    if (dismissed !== bannerId) {
        banner.classList.add('is-visible');
    }

    if (dismissable) {
        banner.querySelector('.notification-banner__close').addEventListener('click', () => {
            banner.classList.remove('is-visible');
            localStorage.setItem(STORAGE_KEY, bannerId);
        });
    }
}
